module.exports = __webpack_public_path__ + "static/media/female_panel_side_dark.e3db9548.png";